(function () {
    'use strict';
    angular.module('app').controller('reroute', reroute);
    reroute.$inject = ['$location', '$scope', '$rootScope', 'gridDataService', 'SelectionCommand_WorkflowService', '$timeout', '$mdDialog', 'records', 'command', 'commandService', 'loginService', 'editEmailsService'];
    function reroute($location, scope, $rootScope, gridDataService, SelectionCommand_WorkflowService, $timeout, $mdDialog, records, command, commandService, loginService, editEmailsService) {

        // =====================================
        // On Load.
        // =====================================

        // Initialize.
        // PL-OBS? scope.rerouteDialogShown = false;
        scope.ACN_ASSIGN_WORKFLOW = 132;
        scope.xyz = { bReadyForOK: false, comment: "", bMakePermanent: false };

        // PL-OBS?
        //scope.$on('rerouteButtonClicked', function (event, arg) {
        //    scope.onRerouteButtonClicked(arg.slx);
        //});

        // =====================================
        // On Load. Workflows.
        // =====================================
        // Set the combo to 'building list'.
        scope.qualifiedWorkflowsArrayLoading = function () {
            // If already on the 'building list', just leave it.
            if (scope.xyz.selectedWorkflowItem != scope.qualifiedWorkflowsBuildingList) {
                // Clear the array.
                scope.qualifiedWorkflowsArray = [];
                // Add 'building list' to the array.
                scope.qualifiedWorkflowsArray.push(scope.qualifiedWorkflowsBuildingList);
                // Select 'building list' in the combo.
                scope.xyz.selectedWorkflowItem = scope.qualifiedWorkflowsBuildingList;
                // We are waiting for the items.
                scope.xyz.gettingWorkflowList = true;
            }
        };
        // Load items into the combo. May be null.
        scope.qualifiedWorkflowsArrayLoad = function (workflows) {
            // Clear the array.
            scope.qualifiedWorkflowsArray = [];
            // Add 'pick one'.
            scope.qualifiedWorkflowsArray.push(scope.qualifiedWorkflowsPickOne);
            // Select 'pick one'.
            scope.xyz.selectedWorkflowItem = scope.qualifiedWorkflowsPickOne;
            // Add ''.
            scope.qualifiedWorkflowsArray.push(scope.qualifiedWorkflowsBlank);
            // If there are items, ...
            if (workflows != null) {
                // Walk the items, ...
                angular.forEach(workflows, function (name, id) {
                    // Add the item to the array.
                    scope.qualifiedWorkflowsArray.push({ id: id, name: name })
                });
            }
            // We are done getting the items.
            scope.xyz.gettingWorkflowList = false;
        }
        // Create a 'building list' item.
        scope.qualifiedWorkflowsBuildingList = { id: 'building_list', name: "- " + loginService.resourceStrings["COMBO_BOX_BUILDING_LIST"] + " -" };
        // Create a 'pick one' item.
        scope.qualifiedWorkflowsPickOne = { id: 'pick_one', name: "- " + loginService.resourceStrings["COMBO_BOX_PICK_ONE"] + " -" };
        // Create a '' item.
        scope.qualifiedWorkflowsBlank = { id: '', name: '' };
        // Initailize to the 'building list' state.
        scope.qualifiedWorkflowsArrayLoading();

        // =====================================
        //
        // =====================================  

        //
        // On step change.
        //
        scope.selectedWorkflowChanged = function () {
            // If nothing selected, then return.
            if (scope.xyz.selectedWorkflowItem == null)
                return;
            // If user selected 'pick one', then return.
            if (scope.xyz.selectedWorkflowItem == scope.qualifiedWorkflowsPickOne)
                return;

            var nameForGrid = scope.xyz.selectedWorkflowItem.name;
            // EDGE-EMPTY
            if (scope.xyz.selectedWorkflowItem.name.length < 1) {
                var browserInfo = navigator.userAgent;
                var bIsEdge = browserInfo.indexOf('Edge/') != -1;
                if (bIsEdge) {
                    // scope.xyz.selectedWorkflowItem.name = '\u00A0';
                    nameForGrid = '\u00A0';
                }
            }
            
            angular.forEach(scope.gridApi.selection.getSelectedRows(), function (gridItem) {
                if (gridItem.bCanReroute) {
                    gridItem.workflowId = scope.xyz.selectedWorkflowItem.id;
                    gridItem.workflow = nameForGrid; // scope.xyz.selectedWorkflowItem.name;
                    gridItem.selectionItem.commandParams.eWorkflowId = scope.xyz.selectedWorkflowItem.id; // *****
                }
            });
 
            // Do Enables.
            scope.doEnables();
        };

        //
        // On comment change.
        //
        scope.onCommentChanged = function () {

            var commentForGrid = scope.xyz.comment;
            // EDGE-EMPTY
            if (scope.xyz.comment.length < 1) {
                var browserInfo = navigator.userAgent;
                var bIsEdge = browserInfo.indexOf('Edge/') != -1;
                if (bIsEdge) {
                    // scope.xyz.comment = '\u00A0';
                    commentForGrid = '\u00A0';
                }
            }

            angular.forEach(scope.gridApi.selection.getSelectedRows(), function (gridItem) {
                gridItem.comment = commentForGrid; // scope.xyz.comment;
                gridItem.selectionItem.commandParams.eWorkflowComment = scope.xyz.comment; // *****
            });

            // Do Enables.
            scope.doEnables();
        };

        //
        // On check/uncheck of the Create Version checkbox.
        //
        scope.makePermanentCheckChanged = function () {
            angular.forEach(scope.gridApi.selection.getSelectedRows(), function (gridItem) {
                gridItem.bMakePermanent = scope.xyz.bMakePermanent ? "T" : "F";
                gridItem.selectionItem.commandParams.ebMakePermanent = scope.xyz.bMakePermanent; // *****
            });

            // Do Enables.
            scope.doEnables();
        };
        
        //
        // Enables.
        //
        scope.wfManager = true;
        scope.doEnables = function () {
            // Does every row have a workflow?
            var bAllHaveTarget = true;
            // Do all steps that require a comment, have one?
            var bAllHaveRequiredComment = true;

            var bOneReq = false;
            scope.wfManager = true;

            // ***** For label updates, only consider selected.
            angular.forEach(scope.gridApi.selection.getSelectedRows(), function (gridItem) {
                if (gridItem.bCommentRequired == 'T') {
                    bOneReq = true;
                }
            });

            // ***** For enable logic, consider all rows.
            angular.forEach(scope.gridOptions.data, function (gridItem) {
                // See if this row has a workflow.
                if (gridItem.workflowId.length < 1)
                    bAllHaveTarget = false;
                // See if this row requires and comment and does not have one.
                if (gridItem.bCommentRequired == 'T' && gridItem.comment.length < 1)
                    bAllHaveRequiredComment = false;
                // If the user is not a workflow manager for any item, set wfManager to false,
                // to prevent enabling the dialog wide checkbox to make the workflow reroute permanent.
                if (!gridItem.selectionItem.detailedInfo.menuEnables.userIsWorkflowManager.enabled) {
                    scope.wfManager = false;
                }
            });

            // Update the comment label.
            if (bOneReq)
                scope.enterCommentLabel = loginService.resourceStrings["ENTER_COMMENT_REQUIRED"]; // "Enter Comment (required)";
            else
                scope.enterCommentLabel = loginService.resourceStrings["ENTER_COMMENT_OPTIONAL"]; // "Enter Comment (optional)";

            // Handle enabling OK.
            scope.xyz.bReadyForOK = bAllHaveTarget && bAllHaveRequiredComment;
        }

        //
        // On selection changed in the grid.
        //
        scope.selectItem = function (item) {

            // Always set all items to not selected.
            angular.forEach(scope.gridOptions.data, function (item) {
                item.isSelected = false;
            });

            // Get the selected items.
            var items = [];
            angular.forEach(scope.gridApi.selection.getSelectedRows(), function (item) {
                item.isSelected = true;
                items.push(item.selectionItem);
            });

            // The main list.
            //var items = scope.gridApi.selection.getSelectedRows();

            // Build the SL with mode and order.
            var slx = { mode: 0, order: 0, list: items };

            // ============================
            // Select Item. Workflows.
            // ===========================+
            // Add users to the combo.
            scope.qualifiedWorkflowsArrayLoading();
            if (items.length < 1) {
                scope.qualifiedWorkflowsArrayLoad();
            }
            else {
                SelectionCommand_WorkflowService.GetWorkflowListForWorkflowCommand(slx, scope.mode).then(function (response) {
                    scope.qualifiedWorkflowsArrayLoad(response.data);
                }, function () {
                    scope.qualifiedWorkflowsArrayLoad();
                });
            }

            // Do Enables.
            scope.doEnables();
        };

        scope.processingLabel = loginService.resourceStrings["PROCESSING"];

        // On click of the Reroute button.
        scope.onRerouteButtonClicked = function (slx) {
            // scope
            scope.slx = slx;
            scope.mode = scope.ACN_ASSIGN_WORKFLOW;
            scope.xyz = { bReadyForOK: false, selectedWorkflowItem: {}, comment: "", bMakePermanent: false };

            // dialog config
            scope.heading = loginService.resourceStrings["REROUTE_ACTIVE_WORKFLOW"]; // "Reroute Active Workflow";
            scope.selectWorkflowLabel = loginService.resourceStrings["SELECT_WORKFLOW"]; // "Select Workflow";
            scope.enterCommentLabel = loginService.resourceStrings["ENTER_COMMENT"]; // "Enter Comment";
            scope.makePermanentLabel = loginService.resourceStrings["MAKE_THIS_ASSIGNMENT_PERMANENT"]; // "Make this assignment permanent";
            scope.filesLabel = loginService.resourceStrings["FILES_TO_REROUTE"]; // "Files to Reroute:";
            scope.OK = loginService.resourceStrings["OK"]; // "OK";
            scope.Cancel = loginService.resourceStrings["CANCEL"]; // "Cancel";
            // dialog config columns
            scope.doColumns();

            // Get options and add to grid.
            scope.gridOptions.data = [];
            SelectionCommand_WorkflowService.GetRerouteOptionsList(slx, scope.mode).then(function (response) {
                // It is OK to keep this seperate because the response item is different than the selection item.
                var bCanReroute = [];
                var bCommentRequired = [];
                angular.forEach(response.data, function (item, key) {
                    var fileId = key;
                    bCanReroute[fileId] = item.bCanReroute;
                    bCommentRequired[fileId] = item.bCommentRequired;
                });

                // For each selection item, add a row to the grid.
                var index = 0;
                angular.forEach(scope.slx.list, function (item) {
                    scope.gridOptions.data.push({
                        index: index,
                        selectionItem: item,
                        isSelected: true,
                        name: item.filename, library: item.detailedInfo.libName,
                        activeWorkflowName: item.detailedInfo.activeWorkflowName, activeStepName: item.detailedInfo.activeStepName,
                        bCanReroute: bCanReroute[item.fileId] ? 'T' : 'F',
                        workflow: '', workflowId: '',
                        bCommentRequired: bCommentRequired[item.fileId] ? 'T' : 'F', comment: "",
                        bMakePermanent: 'F'
                    });
                    index++;
                });

                // Enables.
                scope.selectItem();

                $timeout(function () {
                    refreshGrid();
                    scope.gridApi.selection.selectAllRows();
                    $timeout(function () {
                        refreshGrid();
                    }, 2000);
                }, 500);

            });
        };

        scope.doColumns = function () {
            // dialog config columns
            var colName = loginService.resourceStrings["SCHEMA_S_LONGNAME"];
            var colLibrary = loginService.resourceStrings["SCHEMA_S_LIBNAME"];
            var colActiveWorkflow = loginService.resourceStrings["SCHEMA_S_WFNAME"];
            var colActiveStep = loginService.resourceStrings["SCHEMA_S_STEPNAME"];
            var colWorkflow = loginService.resourceStrings["WORKFLOW"];
            var colComment = loginService.resourceStrings["COMMENT"];
            var colMakePermanent = loginService.resourceStrings["MAKE_PERMANENT"];
            scope.gridOptions.columnDefs[0].name = colName;
            scope.gridOptions.columnDefs[1].name = colLibrary;
            scope.gridOptions.columnDefs[2].name = colActiveWorkflow;
            scope.gridOptions.columnDefs[3].name = colActiveStep;
            scope.gridOptions.columnDefs[4].name = colWorkflow;
            scope.gridOptions.columnDefs[5].name = colComment;
            scope.gridOptions.columnDefs[6].name = colMakePermanent;
        }

        scope.onDisableTest = function () {
            scope.xyz.processing = !scope.xyz.processing;
        }

        scope.onRerouteDialogOK = function () {
            scope.xyz.processing = true;
            // Execute.
            SelectionCommand_WorkflowService.Reroute(scope.slx).then(function (response) {
                // Handle errors.
                var atLeastOneError = false;
                var selectionCommandResults = response.data;
                var slx = selectionCommandResults.slx;
                angular.forEach(slx.list, function (item) {
                    if (atLeastOneError == false) {
                        if (item.ec != 0) {
                            atLeastOneError = true;
                            if (atLeastOneError) {
                                commandService.launchErrors({ slx: slx });
                            }
                        }
                    }
                });
                // Close dialog and refresh grid.
                $mdDialog.hide();
                scope.xyz.processing = false;
                gridDataService.updateGridRecords(slx.list);

                editEmailsService.showEditEmailsDialog(selectionCommandResults.emails);
            });
        };

        scope.onRerouteDialogCancel = function () {
            // Close dialog.
            $mdDialog.hide();
        };

        scope.rerouteDialogClosed = function () {

        }

        var refreshGrid = function () {
            scope.gridApi.grid.handleWindowResize();
            scope.gridApi.grid.refreshCanvas();
            scope.gridApi.grid.refresh();
        }

        var onRegisterApi = function (gridApi) {
            scope.gridApi = gridApi;
            gridApi.selection.on.rowSelectionChanged(scope, scope.selectItem);
            gridApi.selection.on.rowSelectionChangedBatch(scope, scope.selectItem);
            switch (command) {
                case "reroute":
                    scope.onRerouteButtonClicked(records);
                    break;
            }
        }

        scope.gridApi = {};

        scope.gridOptions = {
            data: [],
            enableSelectionBatchEvent: true,
            multiSelect: true,
            modifierKeysToMultiSelect: true,
            enableFullRowSelection: true,
            enableRowHeaderSelection: false,
            useExternalSorting: true,
            enableColumnMenus: false,
            enableColumnResizing: true,
            columnDefs: [
                { name: 'Name', field: 'name', width: '16%', minWidth: '100' },
                { name: 'Library', field: 'library', width: '14%', minWidth: '100' },
                { name: 'Active Workflow', field: 'activeWorkflowName', width: '14%', minWidth: '100' },
                { name: 'Active Step Name', field: 'activeStepName', width: '14%', minWidth: '100' },
                { name: 'Workflow', field: 'workflow', width: '14%', minWidth: '100' },
                { name: 'Comment', field: 'comment', width: '14%', minWidth: '100' },
                { name: 'Make Permanent', field: 'bMakePermanent', width: '14%', minWidth: '100' }],
            onRegisterApi: onRegisterApi
        }

        activate();

        function activate() { }
    }
})();
